<script setup lang="ts">
import { RouterLink } from 'vue-router';

import { translate } from '@/shared/i18n';
import { RouterPages } from '@/shared/router';
import { Btn } from '@/shared/ui';

const emit = defineEmits<{
  (event: 'accept'): void;
  (event: 'reject'): void;
}>();
</script>

<template>
  <div class="fixed inset-x-0 bottom-0 z-50 p-3 sm:p-5">
    <section
      class="mx-auto max-w-2xl rounded-2xl border border-[var(--theme-border-subtle)] bg-[var(--theme-surface-raised)] p-5 shadow-2xl shadow-black/30"
      role="dialog"
      aria-modal="true"
      :aria-label="translate('cookieConsent.title')"
    >
      <div class="flex flex-col gap-4">
        <div class="space-y-2">
          <h2 class="text-base font-semibold text-[var(--theme-text-primary)]">
            {{ translate('cookieConsent.title') }}
          </h2>
          <p class="text-sm text-[var(--theme-text-secondary)]">
            {{ translate('cookieConsent.description') }}
          </p>
          <RouterLink
            class="text-sm text-[var(--button-primary-color)] underline underline-offset-2"
            :to="{ name: RouterPages.PRIVACY }"
            target="_blank"
            rel="noopener noreferrer"
            data-cookie-policy-link
          >
            {{ translate('cookieConsent.policyLink') }}
          </RouterLink>
        </div>

        <div class="flex flex-col gap-2 sm:flex-row sm:justify-end">
          <Btn
            class="min-h-10 px-4 py-2 text-sm font-medium"
            data-consent-action="reject"
            @click="emit('reject')"
          >
            {{ translate('cookieConsent.reject') }}
          </Btn>
          <Btn
            type="primary"
            class="min-h-10 px-4 py-2 text-sm font-medium"
            data-consent-action="accept"
            @click="emit('accept')"
          >
            {{ translate('cookieConsent.accept') }}
          </Btn>
        </div>
      </div>
    </section>
  </div>
</template>
